import { ISortableTableItem } from './types';
import useDataModelerTableExpandedModel from './useDataModelerTableExpandedModel';
import DataModelerTableExpandedContents from './DataModelerTableExpandedContents';
import React from 'react';
import * as FormUI from '../../../pageForm/FormUI';
import { CdwTableLoaderWrapper } from '../DataModelerCommonUI';
import { ContentLoader } from '../../../../components/Loaders';

interface IProps {
  tableItem: ISortableTableItem;
  isEditMode: boolean;
  collapse: () => void;
}

const DataModelerTableExpanded = ({
  tableItem,
  isEditMode,
  collapse,
}: IProps) => {
  const {
    schemaObj,
    searchQuery,
    setSearchQuery,
    serverError,
    availableColumnsFromServer,
    loadingColumns,
  } = useDataModelerTableExpandedModel({ tableItem });

  if (loadingColumns) {
    return (
      <FormUI.Container>
        <CdwTableLoaderWrapper>
          <ContentLoader />
        </CdwTableLoaderWrapper>
      </FormUI.Container>
    );
  }
  return (
    <DataModelerTableExpandedContents
      tableItem={tableItem}
      isEditMode={isEditMode}
      collapse={collapse}
      schemaObj={schemaObj}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      serverError={serverError}
      availableColumnsFromServer={availableColumnsFromServer}
    />
  );
};

export default DataModelerTableExpanded;
